import Class from './c-date-popover';
import './c-date-popover@';

export default Class;